import { lazy } from "react";
import {
  ACCOUNT_STATEMENT_ROUTE,
  AFFILIATE_PROGRAM_ROUTE,
  BONUS_STATEMENT_ROUTE,
  DEPOSIT_ROUTE,
  MY_BETS_ROUTE,
  MY_PROFILE_ROUTE,
  MY_TRANSACTION_ROUTE,
  MY_WALLET_ROUTE,
  PROFIT_LOSS_REPORT_ROUTE,
  RULES_ROUTE,
  STAKE_SETTINGS_ROUTE,
  TURNOVER_REPORT_ROUTE,
  WITHDRAW_ROUTE,
  MOBILE_MENU_ROUTE,
  MULTI_MARKETS_ROUTE,
  POPULAR_EVENTS_ROUTE,
} from "@hypexone/uicore";
import Deposit from "../../pages/Payments/Deposit";
import NotFoundPage from "../../pages/NotFoundPage";
import WithdrawAmount from "../../pages/WithdrawAmount/WithdrawAmount";
import DepositTurnover from "../user-menu-pages/DepositTurnover";
import { Promotions } from "../user-menu-pages/Promotions";
import ChangePassword from "../user-menu-pages/my-profile/ChangePassword";

const MyBet = lazy(() => import("../user-menu-pages/MyBet"));
const MyWallet = lazy(() => import("../user-menu-pages/MyWallet"));
const StakeSettings = lazy(() => import("../user-menu-pages/StakeSettings"));
const MyProfile = lazy(() => import("../user-menu-pages/my-profile/MyProfile"));
const BettingProfitLoss = lazy(
  () => import("../user-menu-pages/BettingProfitLoss")
);
const TurnoverHistory = lazy(
  () => import("../user-menu-pages/TurnOverHistory")
);
const BonusStatement = lazy(() => import("../user-menu-pages/BonusStatement"));
const BonusRewards = lazy(() => import("../user-menu-pages/BonusRewards"));
const MyTransaction = lazy(() => import("../user-menu-pages/MyTransaction"));
const Affiliate = lazy(
  () => import("../user-menu-pages/AffiliateProgram/Affiliate")
);
const Casino = lazy(() => import("../../pages/Casino"));
const MobileUserMenu = lazy(() => import("../../pages/MobileUserMenu"));
const Rules = lazy(() => import("../rules/Rules"));
const AccountStatement = lazy(
  () => import("../user-menu-pages/AccountStatement")
);
const MultiMarketView = lazy(() => import("../multi-market/MultiMarketView"));
const PopularEvents = lazy(() => import("../../pages/PopularEvents"));

export const routesConfig = [
  {
    path: MULTI_MARKETS_ROUTE,
    component: MultiMarketView,
  },
  {
    path: "/casino",
    component: Casino,
  },
   {
    path: "/sports_event/casino",
    component: Casino,
  },
  // For getting mac88 for now, later we can do it for others as well
  {
    path: "/casino/:provider",
    component: Casino,
  },
  {
    path: "/virtual-sports",
    component: Casino,
  },
  {
    path: "/virtual-casino",
    component: Casino,
  },
  {
    path: "/Indian-casino",
    component: Casino,
  },
  {
    path: RULES_ROUTE,
    component: Rules,
  },
  {
    path: ACCOUNT_STATEMENT_ROUTE,
    component: AccountStatement,
  },
  {
    path: "*",
    component: NotFoundPage,
  },
];

export const protectedRoutesConfig = [
  {
    path: ACCOUNT_STATEMENT_ROUTE,
    component: AccountStatement,
  },
  {
    path: PROFIT_LOSS_REPORT_ROUTE,
    component: BettingProfitLoss,
  },
  {
    path: MY_BETS_ROUTE,
    component: MyBet,
  },
  {
    path: MY_WALLET_ROUTE,
    component: MyWallet,
  },
  {
    path: AFFILIATE_PROGRAM_ROUTE,
    component: Affiliate, 
  },
  {
    path: TURNOVER_REPORT_ROUTE,
    component: TurnoverHistory,
  },
  {
    path: BONUS_STATEMENT_ROUTE,
    component: BonusStatement,
  },
  {
    path: "/deposit-turnover", // TODO: UI core
    component: DepositTurnover,
  },
  {
    path: "/promotions",
    component: Promotions,
  },
  {
    path: "/bonus_rewards",
    component: BonusRewards,
  },

  {
    path: MY_TRANSACTION_ROUTE,
    component: MyTransaction,
  },
  {
    path: STAKE_SETTINGS_ROUTE,
    component: StakeSettings,
  },
  {
    path: MY_PROFILE_ROUTE,
    component: MyProfile,
  },
  {
    path: "/change-password",
    component: ChangePassword,
  },
  {
    path: WITHDRAW_ROUTE,
    component: WithdrawAmount,
  },
  // {
  //   path: TERMS_AND_POLICY_ROUTE,
  //   component: >Terms And Policy</>,
  // },
  {
    path: RULES_ROUTE,
    component: Rules,
  },
  {
    path: DEPOSIT_ROUTE,
    component: Deposit,
  },
  {
    path: WITHDRAW_ROUTE,
    component: Deposit,
  },
  {
    path: MOBILE_MENU_ROUTE,
    component: MobileUserMenu,
  },
  {
    path: POPULAR_EVENTS_ROUTE,
    component: PopularEvents,
  },
];
